import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";
import "./Fetch";
import "./HistoryBack";
import "./LockScroll";
import "./Magics";

Alpine.plugin([focus, collapse, intersect, persist]);

const setFullHeight = () => {
    document.documentElement.style.setProperty("--full-height", `${window.innerHeight}px`);
};

window.addEventListener("resize", setFullHeight);
setFullHeight();

export default Alpine;
